<div class="whole-container">
    <div class="top-section-container">
        <div class="top-section generic-container">
            <mat-icon class="icon" (click)="goBack()"><mat-icon>arrow_back</mat-icon></mat-icon>
            <span class="title">Wishlist</span>
        </div>
    </div>

    <mat-spinner *ngIf="isLoading" class="loading-spinner" [diameter]="50"></mat-spinner>
    <div class="product-section-container" *ngIf="!isLoading && wishlistData.length; else noProducts">
        <div class="product-section generic-container">
            @for (product of wishlistData; track $index) {
            <div class="animate-fade-in" [ngStyle]="{ 'animation-delay': $index * 0.05 + 's' }">
                <div class="product-card" *ngIf="product" [class.inactive]="!product.isActive">
                    <!-- Image Container -->
                    <div class="image-container">
                        <img [src]="product.images.imagesUrl[0]" [alt]="product.name" class="product-image" />
                        <div class="out-of-stock" *ngIf="!product.isActive">
                            {{ "wishlist.outOfStock" | translate }}
                        </div>

                        <!-- Badges -->
                        <div class="badges">
                            <app-badge *ngIf="product.discountPercentage" class="badge-discount"
                                >{{ product.discountPercentage }}% OFF</app-badge
                            >
                        </div>

                        <!-- Favorite Button -->
                        <app-button
                            variant="ghost"
                            size="icon"
                            (onClick)="deleteWishlistItem(product)"
                            class="favorite-button"
                            buttonClass="favorite-button"
                            [disabled]="itemLoadingState[product.id]"
                        >
                            <mat-icon>close</mat-icon>
                        </app-button>

                        <!-- Quick Add to Cart Overlay -->
                        <div class="quick-add-overlay" (click)="onClickProduct(product.id)"></div>
                    </div>

                    <!-- Product Info -->
                    <div class="product-info">
                        <h3 class="product-name transition-colors">
                            {{ product.name }}
                        </h3>

                        <!-- Rating -->
                        <div class="rating-section">
                            <div class="stars" *ngIf="product.averageRating">
                                <mat-icon
                                    *ngFor="let star of getStarsArray(); let i = index"
                                    class="star"
                                    [ngClass]="{ filled: i < getFilledStars(product) }"
                                    aria-hidden="true"
                                    aria-label="star icon"
                                    fontIcon="star"
                                ></mat-icon>
                            </div>
                            <span class="rating-text" *ngIf="product.averageRating">
                                {{ product.averageRating }} ({{ product.reviews?.length }})
                            </span>
                        </div>

                        <!-- Price -->
                        <div class="price-section">
                            <div class="price-group">
                                <span class="current-price"> ₹{{ formatPrice(product.price) }} </span>
                                <span *ngIf="product.price" class="original-price">
                                    ₹{{ formatPrice(product.price) }}
                                </span>
                            </div>

                            <app-button
                                variant="outline"
                                size="icon"
                                buttonClass="product-card-cart-button"
                                (onClick)="moveToCart(product, 1)"
                                [disabled]="isLoading || !product.isActive || itemLoadingState[product.id]"
                            >
                                <mat-icon
                                    aria-hidden="true"
                                    aria-label="cart icon"
                                    fontIcon="shopping_cart"
                                    class="material-icons-outlined cart-icon-small"
                                ></mat-icon>
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="btn-content" *ngIf="showViewMoreButton()">
            <app-button variant="hero" buttonClass="explore-btn shadow-btn" (onClick)="loadMoreWishlistItems()">
                {{ "wishlist.button.viewMoreBtn" | translate }}
            </app-button>
        </div>
    </div>

    <ng-template #noProducts>
        <div class="empty-cart-container">
            <div class="empty-cart" *ngIf="!isLoading">
                <div class="empty-cart-image-container">
                    <mat-icon
                        svgIcon="emptyWishlist"
                        class="emptyCartIcon"
                        aria-hidden="false"
                        aria-label="Empty Cart"
                    />
                </div>
                <div class="message">
                    <span>{{ "wishlist.messageSaveItems" | translate }}</span>
                </div>
                <app-button variant="hero" buttonClass="explore-btn shadow-btn" (onClick)="clickShopNow()">
                    {{ "wishlist.button.shopNowBtn" | translate }}
                </app-button>
            </div>
        </div>
    </ng-template>
</div>
